import { elementContainsTarget } from 'cio/utils/dom';
import Ember from 'ember';

export const TOOLTIPS_SELECTOR = '#fly-tooltips';
export const MODALS_SELECTOR = '#fly-modals';
export const DROPDOWN_MENUS_SELECTOR = '#dropdown-menus';
export const EMBER_BASIC_DROPDOWN_SELECTOR = '#ember-basic-dropdown-wormhole';
export const EMBER_BASIC_DROPDOWN_CONTENT_SELECTOR = '.ember-basic-dropdown-content';

const DEFAULT_TARGET = 'target';

export function isEventTargetInWormhole(event, targetProperty = DEFAULT_TARGET) {
  let target = event[targetProperty];

  if (target == null && targetProperty !== DEFAULT_TARGET) {
    target = event[DEFAULT_TARGET];
  }

  let inTooltip = elementContainsTarget(document.querySelector(TOOLTIPS_SELECTOR), target);
  let inModal = elementContainsTarget(document.querySelector(MODALS_SELECTOR), target);
  let inDropdown = elementContainsTarget(document.querySelector(DROPDOWN_MENUS_SELECTOR), target);
  let inEmberBasicDropdown = elementContainsTarget(document.querySelector(EMBER_BASIC_DROPDOWN_SELECTOR), target);

  let isEventTargetInWormhole = inTooltip || inModal || inDropdown || inEmberBasicDropdown;

  if (Ember.testing) {
    // in tests, ember-basic-dropdown doesn't render into the usual container,
    // but to the root container directly, so we need to run a different check.
    // This may be fixed once
    // https://github.com/cibernox/ember-basic-dropdown/issues/495 is addressed.
    let inTestEmberBasicDropdown = elementContainsTarget(
      document.querySelector(EMBER_BASIC_DROPDOWN_CONTENT_SELECTOR),
      target,
    );
    return isEventTargetInWormhole || inTestEmberBasicDropdown;
  }

  return isEventTargetInWormhole;
}
